export const TITLE_PREFIX = 'Ververica Cloud - ';
